<template>
  <div>
    <vs-table :data="profiles">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between mb-4">
        <div class="flex flex-wrap-reverse data-list-btn-container items-center">
          <vs-button
            class="p-4 shadow-drop mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium"
            color="primary"
            @click="() => $router.push({ name: 'hello-dna-profile-batch-update' })"
          >
            <feather-icon icon="EditIcon" svgClasses="h-4 w-4" />
            Batch Update
          </vs-button>

          <date-picker v-model="dateRange" range class="mr-2"></date-picker>

          <v-select v-model="status" :options="statusList" :reduce="status => status.value" label="text" :clearable='false' class="bg-white"></v-select>
        </div>

        <vs-input
          icon-no-border
          placeholder="Search"
          v-model="search"
          class="input-rounded-full"
          icon="icon-search"
          icon-pack="feather"
        />
      </div>

      <template slot="thead">
        <vs-th>
          DNA Code
        </vs-th>
        <vs-th>
          Lab Sample ID
        </vs-th>
        <vs-th>
          Full Name
        </vs-th>
        <vs-th>
          IC No
        </vs-th>
        <vs-th>
          Phone Number
        </vs-th>
        <vs-th>
          Email
        </vs-th>
        <vs-th>
          Gender
        </vs-th>
        <vs-th>
          Kit Category
        </vs-th>
        <vs-th>
          Status
        </vs-th>
        <vs-th>
          Created At
        </vs-th>
        <vs-th>
          Action
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].dnaCode">
            {{ data[indextr].dnaCode }}
          </vs-td>

          <vs-td :data="data[indextr].dnaCode">
            {{ data[indextr].labSampleId }}
          </vs-td>

          <vs-td :data="data[indextr].fullName">
            {{ data[indextr].fullName }}
          </vs-td>

          <vs-td :data="data[indextr].icNo">
            {{ data[indextr].icNo }}
          </vs-td>

          <vs-td :data="data[indextr].phoneNumber">
            {{ data[indextr].phoneNumber }}
          </vs-td>

          <vs-td :data="data[indextr].email">
            {{ data[indextr].email }}
          </vs-td>

          <vs-td :data="data[indextr].gender">
            {{ data[indextr].gender }}
          </vs-td>

          <vs-td :data="data[indextr].kitCategory">
            {{ getKitCategoryText(data[indextr].kitCategory) }}
          </vs-td>

          <vs-td :data="data[indextr].status">
            {{ getStatusText(data[indextr].status) }}
          </vs-td>

          <vs-td :data="data[indextr].createdAt">
            {{ data[indextr].createdAt | moment('DD MMM YYYY, hh:mm A') }}
          </vs-td>


          <vs-td class="whitespace-no-wrap">
            <feather-icon
              icon="EditIcon"
              svgClasses="w-5 h-5 hover:text-primary stroke-current mr-2"
              @click.stop="handleEdit(tr)"
            />
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <Pagination :total="totalPage" v-model="currentPage" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import _ from 'lodash';
import Pagination from '@/components/Pagination';
import { DnaKitStatus, DnaKitCategory } from './dna-enum.js';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/en';

export default {
  components: {
    Pagination,
    DatePicker,
  },
  data() {
    return {
      search: '',
      itemsPerPage: 10,
      currentPage: 1,
      pageTotal: 0,
      totalItem: 0,
      totalPage: 0,
      status: '',
      filter: {},
      dateRange: [],
    };
  },
  computed: {
    getKitCategoryText() {
      return cat => {
        const found = _.find(DnaKitCategory, s => s.value == cat);
        return found ? found.text : cat;
      };
    },
    getStatusText() {
      return status => {
        const foundStatus = _.find(DnaKitStatus, s => s.value == status);
        return foundStatus ? foundStatus.text : status;
      };
    },
    statusList() {
      return [
        { text: 'All', value: '' },
        ...DnaKitStatus
      ];
    },
    queryParams() {
      return {
        page: this.currentPage,
        limit: this.itemsPerPage,
        filter: [..._.values(this.filter)],
        sort: 'createdAt,DESC'
      };
    },
    ...mapState({
      profiles: ({ helloDnaProfile }) => helloDnaProfile.helloDnaProfiles,
    }),
  },
  methods: {
    ...mapActions({
      getHelloDnaProfiles: 'helloDnaProfile/getHelloDnaProfiles',
    }),
    handleEdit(profile) {
      this.$router.push({ name: 'hello-dna-profile-edit', params: { id: profile.id }});
    },
    fetchData(resetCurrentPage = false) {
      if(resetCurrentPage) this.currentPage = 1;

      this.getHelloDnaProfiles(this.queryParams)
      .then(response => {
        this.currentPage = +response.headers['x-pagination-page'];
        this.pageTotal = +response.headers['x-pagination-count'];
        this.totalItem = +response.headers['x-pagination-total'];
        this.totalPage = +response.headers['x-pagination-page-count'];
      })
      .catch(err => {
        console.error(err);
      })
    },
  },
  mounted() {
    this.fetchData();
  },
  watch: {
    search: _.debounce(async function(newValue, oldValue) {
      if (newValue !== oldValue) {
        let params = {};
        if (newValue) {
          params = {
            ...params,
            page: 1, // back to first page upon searching
            or: [`fullName||$cont||${this.search}`, `icNo||$eq||${this.search}`, `phoneNumber||$eq||${this.search}`, `email||$eq||${this.search}`, `dnaCode||$eq||${this.search}`, `labSampleId||$eq||${this.search}`],
          };
        }
        this.getHelloDnaProfiles({
          ...params,
          ...this.queryParams,
        }).then(response => {
          this.currentPage = +response.headers['x-pagination-page'];
          this.pageTotal = +response.headers['x-pagination-count'];
          this.totalItem = +response.headers['x-pagination-total'];
          this.totalPage = +response.headers['x-pagination-page-count'];
        })
        .catch(err => {
          console.error(err);
        });
      }
    }, 1000),
    async currentPage(newValue, oldValue) {
      if (newValue !== oldValue) {
        await this.fetchData();
      }
    },
    status() {
      if(this.status) {
        this.$set(this.filter, 'status', `status||$eq||${this.status}`);
      } else {
        this.$delete(this.filter, 'status');
      }

      return this.fetchData({ resetCurrentPage: true });
    },
    dateRange() {
      if(this.dateRange[0] && this.dateRange[1]) {
        const field = 'createdAt';
        const end = moment(this.dateRange[1]).format('YYYY-MM-DD 23:59:59');

        this.$set(this.filter, 'dateRangeStart', `${field}||$gte||${this.dateRange[0].toISOString()}}`);
        this.$set(this.filter, 'dateRangeEnd', `${field}||$lte||${moment(end).toISOString()}`);
      } else {
        this.$delete(this.filter, 'dateRangeStart');
        this.$delete(this.filter, 'dateRangeEnd');
      }

      return this.fetchData({ resetCurrentPage: true });
    },
  },
}
</script>
